import { BooleanBase } from '../BooleanBase';

export class PremiumOTT extends BooleanBase {}
